import React, { useEffect, useState, useRef } from "react"
import { getGCSFlightStats, getGCSFlights, getGCSFlightsGraphStats, deleteFlightData } from "../../api"
import InteractiveGraph from "../Components/InteractiveGraph"
import FlightsFilter from "../Components/FlightsFilter/FlightsFilter"
import "./Flights.css"
import TableView from "../../ReusableComponents/TableView/TableView"
import { useHistory, useLocation } from "react-router-dom"
import { BreadCrumbs } from "../../ReusableComponents/BreadCrumbs"
import { Popup, addUserAnalytic, updateOutTime } from "../../ReusableComponents/reusableFunctions"
import Cookies from "universal-cookie"
import LoaderComponent from "../../ReusableComponents/LoaderComponent"
import { useFirstRender } from "../../ReusableComponents/firstRender"
import { GCS_FEATURES, getActiveTeam, getFeaturesPermissions } from "../../Teams"
import { ActivityPopup } from "../../ReusableComponents/ActivityPopup"
import flightReplay from "../../replayVideo.svg";
import dateFormat from 'dateformat';
import FlightChart from "./FlightChart"
import Select from "react-dropdown-select"
import InMaintenanceIcon from '../../InMaintenanceIcon.svg';
import { useIsFreePlan } from "../../redux/Profile/useSubscription";
import { FEATURE_NOT_AVAILABLE_FOR_FREE_USERS_MESSAGE, FREE_PLAN_FLIGHT_ACCESS_DAYS } from "../../AppConstants";


export const getFlightTime = (flightObj) => {
    const flights = Object.entries(flightObj).filter(flight => flight[0] !== "milliseconds");

    // If the first two entries are days and hours, include the third entry
    if (flights.length >= 2 && flights[0][0] === 'days' && flights[1][0] === 'hours') {
        if (flights?.[2])
            flights.push([flights[2][0], flights[2][1]]); // Include the third entry
    }

    // flights.splice(2); // Take only the first two entries

    if (flights.length === 0) return `0`;

    let time1 = Number(flights[0][1]);
    let time2 = Number(flights?.[1]?.[1]);
    let interval1 = flights[0][0];
    let interval2 = flights?.[1]?.[0];

    // Modify interval1 and interval2
    switch (interval1) {
        case 'days':
            time1 *= 24; // Convert days to hours
            if (interval2 === 'hours') {
                time1 += time2; // Add hours
                interval1 = 'h'; // Change interval1 to hours
                time2 = flights?.[2]?.[1] || 0; // Reset time2
                interval2 = flights?.[2]?.[0] || ""; // Reset interval2
            } else {
                interval1 = 'h'; // Change interval1 to hours
            }
            break;
        case 'hours':
            interval1 = 'h';
            break;
        case 'minutes':
            interval1 = 'm';
            break;
        case 'seconds':
            interval1 = 's';
            break;
        case 'milliseconds':
            interval1 = 'ms';
            break;
    }

    // Modify interval2
    if (interval2) {
        switch (interval2) {
            case 'days':
                time2 *= 24; // Convert days to hours
                interval2 = 'h'; // Change interval2 to hours
                break;
            case 'hours':
                interval2 = 'h';
                break;
            case 'minutes':
                interval2 = 'm';
                break;
            case 'seconds':
                interval2 = 's';
                break;
            case 'milliseconds':
                interval2 = 'ms';
                break;
        }
    }
    return `${time1} ${interval1} ${interval2 ? `${time2} ${interval2}` : ""}`;
}

const Flights = (props) => {
    const cookies = new Cookies()
    const { user, type } = props.location.state
    const history = useHistory();
    const location = useLocation();
    const isFreePlan = useIsFreePlan();
    const [flights, setFlights] = useState([])
    const [flightsStats, setFlightsStats] = useState(null)
    const [flightsGraphStats, setFlightsGraphStats] = useState(null)
    const [tableState, setTableState] = useState({
        pageNumber: 1,
        pageSize: 15,
    })
    const [filterState, setFilterState] = useState(null)
    const [flightsTableLoading, setFlightsTableLoading] = useState(true)
    const [cookieData, setCookieData] = useState()
    const [permissions, setPermissions] = useState()
    const [activityPopup, setActivityPopup] = useState(undefined)
    const [deleteData, setDeleteData] = useState(undefined)
    const [outId, setOutId] = useState("")
    const [activeTeam, setActiveTeam] = useState('')
    const [selectedChartType, setSelectedChartType] = useState('sprayed_area')
    const initialLoadComplete = useRef(false);

    const getFlights = async () => {
        try {
            setFlightsTableLoading(true)
            const flights = await getGCSFlights({ ...tableState, ...filterState })
            setFlights(flights)
            setFlightsTableLoading(false)
        }
        catch (e) {
            setFlightsTableLoading(false)
            Popup.alert("ERROR", e?.message || e)
        }
    }

    const getFlightsStats = async () => {
        try {
            setFlightsStats(null)
            const flightsStats = await getGCSFlightStats(filterState)
            setFlightsStats(flightsStats)
        }
        catch (e) {
            Popup.alert("ERROR", e?.message || e)
        }
    }

    const getFlightsGraphStats = async () => {
        try {
            setFlightsGraphStats(null)
            const flightsGraphStats = await getGCSFlightsGraphStats(filterState)

            setFlightsGraphStats(flightsGraphStats)
        }
        catch (e) {
            Popup.alert("ERROR", e?.message || e)
        }
    }

    const firstRender = useFirstRender();

    useEffect(() => {
        if (!initialLoadComplete.current) return;

        if (filterState) {
            const page_data = cookies.get("page_data");
            const newPageData = { ...page_data, flights: { ...page_data?.flights, ...filterState } }
            cookies.set('page_data', JSON.stringify(newPageData), { path: "/" })
            getFlightsGraphStats()
            getFlightsStats()
            getFlights()
        }
    }, [filterState])

    useEffect(() => {
        if (!initialLoadComplete.current) return;

        if (tableState) {
            const page_data = cookies.get("page_data");
            const newPageData = { ...page_data, flights: { ...page_data?.flights, tableState: tableState } };
            cookies.set('page_data', JSON.stringify(newPageData), { path: "/" });
            getFlights()
        }
    }, [tableState])

    useEffect(() => {
        if (initialLoadComplete.current) return;

        const loadInitialData = async () => {
            const page_data = cookies.get("page_data");
            const data = page_data?.flights || {}
            setTableState(prev => ({ ...prev, pageNumber: data?.tableState?.pageNumber || prev.pageNumber }))
            if (data.tableState) {
                setTableState(data.tableState);
            }
            setCookieData(data)
            if (location.state?.filterState) {
                setFilterState(location.state.filterState);
            } else {
                const { tableState, ...persistedFilters } = data;
                if (Object.keys(persistedFilters).length > 0) {
                    setFilterState(persistedFilters);
                }
            }

            const id = await addUserAnalytic(props.location.pathname);
            setOutId(id);
            const activeTeam = await getActiveTeam();
            setActiveTeam(activeTeam);
            const permissions = await getFeaturesPermissions([GCS_FEATURES.PLANS]);
            setPermissions(permissions);
            initialLoadComplete.current = true;
        };
        loadInitialData();
    }, []);

    useEffect(() => { return () => { updateOutTime(outId) } }, [outId])

    const getCookieData = () => {
        return cookies.get("page_data")
    }

    const closeActivityPopup = () => {
        setActivityPopup(undefined)
    }

    const deleteFlight = async () => {
        try {
            setActivityPopup({
                open: true,
                msg: 'Deleting flight and related data please wait...',
                item: "WAIT",
                icon: "WAIT",
            })
            const data = await deleteFlightData(deleteData.id)
            setActivityPopup({
                open: true,
                msg: data.message,
                item: "COMPLETE",
                icon: "COMPLETE",
            })
            setDeleteData(undefined)
            getFlightsGraphStats()
            getFlightsStats()
            getFlights()
        } catch (e) {
            setDeleteData(undefined)
            closeActivityPopup()
            Popup.alert("ERROR", e?.message || e)
        }
    }

    const didMount = useRef(false);

    useEffect(() => {
        if (location.state && location.state.filterState) {
            setFilterState(location.state.filterState);
        }
        didMount.current = true;
    }, []);

    useEffect(() => {
        if (!didMount.current) return;
        if (
            filterState &&
            (!location.state || JSON.stringify(location.state.filterState) !== JSON.stringify(filterState))
        ) {
            history.replace({
                pathname: location.pathname,
                state: {
                    ...props.location.state,
                    filterState,
                },
            });
        }
    }, [filterState]);

    const getChartData = () => {
        if (!flightsStats) return { data: [], totalFlights: 0 };

        const statsToUse = selectedChartType === 'sprayed_area'
            ? flightsStats.areaRangeStats
            : flightsStats.acresByPilotStats;

        const validStats = statsToUse?.filter(
            (item) => item.area_range !== "Unknown"
        ) || [];

        const [lv1, lv2, lv3, lv4, lv5] = validStats.map(item => Number(item.flight_count));
        const [area1, area2, area3, area4, area5] = validStats.map(item => Number(item.total_area_covered));
        return {
            lv1: lv1 ?? 0,
            lv2: lv2 ?? 0,
            lv3: lv3 ?? 0,
            lv4: lv4 ?? 0,
            lv5: lv5 ?? 0,
            area1: area1 ?? 0,
            area2: area2 ?? 0,
            area3: area3 ?? 0,
            area4: area4 ?? 0,
            area5: area5 ?? 0,
        };
    };

    const chartData = getChartData();

    return <div className="wrapper" style={{ fontFamily: 'Lato' }}>
        <div className="right-content-new">
            <div className="top-bar-new">
                <div className="top-bar-text-new">
                    <BreadCrumbs
                        data={props.location.state.project ?
                            [
                                {
                                    displayName: "projects",
                                    pathname: "/aerogcsenterprise/projects",
                                    state: {
                                        type,
                                        user,
                                    }
                                },
                                {
                                    displayName: props.location.state.project.project_name,
                                    pathname: "/aerogcsenterprise/plans",
                                    state: {
                                        type,
                                        user,
                                        plan: props.location.state.plan,
                                        project: props.location.state.project,
                                    }
                                },
                                {
                                    displayName: props.location.state.plan.plan_name,
                                    pathname: "/aerogcsenterprise/remote_mission/assignDroneToPlan",
                                    state: {
                                        type,
                                        user,
                                        plan: props.location.state.plan,
                                        project: props.location.state.project,
                                    }
                                },
                                {
                                    displayName: "Flights"
                                }
                            ]
                            : [
                                {
                                    displayName: "Home",
                                    pathname: "/",
                                    state: {
                                        user
                                    }
                                },
                                ...(location.state.lastPage == 'Drone Performance' ? [{
                                    displayName: "Drone Performance",
                                    pathname: "/aerogcsenterprise/remote_mission/flights_completed_hours"
                                }] : []),
                                {
                                    displayName: 'Flights',
                                }
                            ]} />
                </div>
            </div>
            <div className="main-content-new flights-main-content" >
                {!activeTeam ? (
                    <LoaderComponent message="Loading, please wait..." />
                ) : activeTeam.isOwner ? <>
                    <ActivityPopup
                        item={activityPopup?.item}
                        open={activityPopup?.open}
                        icon={activityPopup?.icon}
                        msg={activityPopup?.msg}
                        close={() => { closeActivityPopup() }}
                        onClickOk={() => { deleteFlight() }}
                    />
                    {cookieData ? <>
                        <FlightsFilter
                            cookiesData={cookieData.pageNumber}
                            stats={{
                                "Flights": flightsStats?.total_flights || 0,
                                "Flight Time": flightsStats?.total_flight_time ? getFlightTime(flightsStats.total_flight_time) : 0,
                                "Pilots worked": flightsStats?.total_pilots || 0,
                                "Utilize Drones": flightsStats?.total_drones_utilize || 0,
                            }}
                            statsSecondRow={{
                                "Sprayed Area (Acr)": `${flightsStats?.total_acres_covered ? `${Math.round(Number(flightsStats.total_acres_covered) / 4046.85642)}` : 0}`,
                                "Acres By Pilot": `${flightsStats?.acres_by_pilot ? `${flightsStats.acres_by_pilot}` : 0}`
                            }}
                            selectedTab={filterState?.selectedTab || props.location.state.interval || cookieData?.selectedTab}
                            selectedDrone={props.location.state.selectedDrone || filterState?.selectedDrones?.[0] || cookieData?.selectedDrones?.[0]}
                            selectedPilot={filterState?.selectedPilots?.[0] || props.location.state.selectedPilot || cookieData?.selectedPilots?.[0]}
                            defaultFromDateTime={filterState?.fromDateTime || cookieData?.fromDateTime}
                            defaultToDateTime={filterState?.toDateTime || cookieData?.toDateTime}
                            filterState={{ ...tableState, ...filterState }}
                            onFilterDataChange={(data) => {
                                if (data.refresh !== 1) setTableState({ ...tableState, pageNumber: 1 })
                                const { pageNumber, ...rest } = data;
                                setFilterState({ ...rest, projectName: props.location?.state?.project?.project_name, planName: props.location?.state?.plan?.plan_name });
                            }}
                            isPilotEnable={true}
                        />

                        <div style={{ width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "30px" }}>
                            <div style={{ width: "60%", height: "100%", alignItems: "center" }}>
                                <InteractiveGraph
                                    showZoom
                                    data={flightsGraphStats?.length > 1 ? flightsGraphStats : []}
                                    loading={!flightsGraphStats}
                                    lineType={0}
                                    fromDate={filterState?.fromDateTime}
                                    interval={filterState?.selectedTab?.toLowerCase() || undefined}
                                    style={{ height: '100%' }}
                                />
                            </div>
                            <div style={{ width: "40%", height: "400px", margin: "28px 0px 0px 0px", padding: "20px", backgroundColor: "white", border: "1px solid #e9ecef", display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "flex-end" }}>
                                <div style={{ width: "190px", height: "20px", margin: "5px 0px", display: "flex", alignItems: "flex-end", justifyContent: "flex-end", alignItems: "flex-end" }}>
                                    <Select
                                        placeholder="Select graph type"
                                        options={[
                                            { label: 'Sprayed Area (Acr)', value: 'sprayed_area' },
                                            { label: 'Acres By Pilot', value: 'acres_by_pilot' }]}
                                        values={[{
                                            label: selectedChartType === 'sprayed_area' ? 'Sprayed Area (Acr)' : 'Acres By Pilot',
                                            value: selectedChartType
                                        }]}
                                        className="custom_dropdown"
                                        style={{ borderRadius: "7px", fontSize: "13px" }}
                                        onChange={(values) => {
                                            if (values.length > 0) {
                                                setSelectedChartType(values[0].value);
                                            }
                                        }}
                                    />
                                </div>
                                {(flightsGraphStats) ?
                                    <FlightChart lv1={chartData.lv1} lv2={chartData.lv2} lv3={chartData.lv3} lv4={chartData.lv4} lv5={chartData.lv5} area1={chartData.area1} area2={chartData.area2} area3={chartData.area3} area4={chartData.area4} area5={chartData.area5} chartType={selectedChartType} />
                                    : <LoaderComponent message="Loading, please wait..." />
                                }
                            </div>
                        </div>
                        <div className="table-container" style={{ height: "96%" }}>
                            <TableView
                                pageNumber={tableState.pageNumber}
                                onStateChange={(state) => { setTableState(state) }}
                                isLoading={flightsTableLoading}
                                onClickRow={(flight) => {
                                    console.log('flight', flight);
                                    delete flight.maintencance_icon
                                    delete flight.link_data;
                                    history.push('/aerogcsenterprise/remote_mission/flight_details', {
                                        user: user,
                                        flightId: flight.id,
                                        fromScreen: location.state.lastPage == 'Drone Performance' ? "Drone Performance" : "Flights"
                                    });
                                }}
                                columns={[
                                    { Header: '', accessor: 'maintencance_icon', isSortable: false, isCenter: true, onHoverText: 'Drone is in maintenance' },
                                    { Header: "Project/Plan Name", accessor: "projectPlanName", width: '17%' },
                                    { Header: "Drone", accessor: "drone_name", width: '8%', isSortable: true },
                                    { Header: "Start/End Time", accessor: "flightDate", width: '20%', },
                                    { Header: "Total Time", accessor: "total_flight_time", width: '10%', isSortable: true },
                                    { Header: "Distance (M)", accessor: "distance_covered", width: '10%', isSortable: true },
                                    { Header: "Sprayed Area (Acr)", accessor: "area_covered", width: '10%', isSortable: true },
                                    { Header: "Acres By Pilot", accessor: "acres", width: '10%', isSortable: true },
                                    { Header: "Consumed Liquid (ml)", accessor: "consumed_liquid", width: '10%', isSortable: true },
                                    { Header: "Replay", accessor: "link_data", width: '5%', isIcon: true, isCenter: true },
                                ]}
                                count={flightsStats?.total_flights}
                                data={flights?.map((flight) => {
                                    // Check if flight.end_time is more than 7 days ago and user is on free plan
                                    let hasNoAccessForFreePlan = false;
                                    if (isFreePlan) {
                                        const endTime = new Date(flight.end_time);
                                        const today = new Date();
                                        const daysDifference = (today - endTime) / (1000 * 60 * 60 * 24); // Convert milliseconds to days
                                        hasNoAccessForFreePlan = daysDifference > FREE_PLAN_FLIGHT_ACCESS_DAYS;
                                    }

                                    return ({
                                        ...flight,
                                        maintencance_icon: flight.is_drone_in_maintenance ? <img style={{ width: "20px", height: '20px' }} src={InMaintenanceIcon} /> : undefined,
                                        flightDate: `${dateFormat(flight.start_time, "dd/mm/yyyy hh:MM TT")} / ${dateFormat(flight.end_time, "hh:MM TT")}`,
                                        hasNoAccessForFreePlan: hasNoAccessForFreePlan,
                                        projectPlanName: `${flight.project_name}/${flight.plan_name}`,
                                        total_flight_time: getFlightTime(flight.total_flight_time),
                                        area_covered: (Number(flight.area_covered) / 4046.85642).toFixed(4),
                                        link_data: {
                                            img: flightReplay,
                                            onClick: (flight) => { 
                                                if (hasNoAccessForFreePlan) {
                                                    Popup.alert("WARNING_NOTE", FEATURE_NOT_AVAILABLE_FOR_FREE_USERS_MESSAGE, () => {
                                                        props.history.push("/aeroGCS_plans", { user: user, serviceName: "AeroGCS Enterprise", currentPlan: user.sub });
                                                    }, () => { });
                                                } else {
                                                    props.history.push("/aerogcsenterprise/drone_control_center/fly_view", { flight: flight.id, user: user, replyData: 0 })
                                                }
                                            }
                                        },
                                        acres: flight.acres === null ? 0 : flight.acres
                                    })
                                }) || []}
                                activities={{
                                    disableDelete: !permissions?.[GCS_FEATURES.PLANS]?.DELETE,
                                    onClickDelete: (flight) => {
                                        setDeleteData(flight)
                                        setActivityPopup({
                                            open: true,
                                            msg: 'Are you sure you want to delete selected flight and related data. (ie. streaming video, images, flight logs) ?',
                                            item: "WARNING",
                                            icon: "WARNING",
                                        })
                                    }
                                }}
                                user={user}
                            />
                        </div>
                    </> : <LoaderComponent message="Loading Flights, please wait..." />}
                </> : <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", height: "75vh" }}>
                    {`You dont have access to flights of ${activeTeam?.teamName} `}
                </div>}
                <div style={{ width: "100%", height: "45px" }}></div>
            </div>
        </div>
    </div>
}
export default Flights
